import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as checkoutWizardActions from 'actions/checkoutWizardActions';
import * as countriesActions from 'actions/countriesActions';

import Wizard from 'components/Wizard';
import PublisherEnterprisePackagePage from 'containers/PublisherEnterprisePackagePage';
import SecureCheckoutPage from 'containers/SecureCheckoutPage';
import { getPreviewUrl } from 'lib/support';
import { trackPageView } from 'lib/eventTracking'

class PublisherCheckoutWizardContainer extends Component {
  static propTypes = {
    currentStep: PropTypes.number.isRequired,
    goToStep: PropTypes.func.isRequired,
    snapSell: PropTypes.bool,
    currentEvent: ImmutablePropTypes.map,
    currentUser: ImmutablePropTypes.map,
    fetchCountries: PropTypes.func.isRequired,
    history: PropTypes.object,
  };

  static defaultProps = {
    snapSell: false,
  }

  componentWillMount() {
    this.props.fetchCountries();
    if (this.getSteps().length > 2 && this.props.currentStep === 1) this.props.goToStep(2);
  }

  componentDidMount() {
    trackPageView('Publisher Checkout Wizard');
  }

  getSteps() {
    const { currentEvent, currentUser } = this.props;
    let steps = [
      {
        name: 'Package',
        faIconClass: 'fa fa-cubes',
        component: <PublisherEnterprisePackagePage/>,
        accessible: true,
        completed: this.props.currentStep > 1
      },
      {
        name: 'Secure Checkout',
        faIconClass: 'fa fa-flag',
        component: <SecureCheckoutPage/>,
        accessible: true,
        completed: false
      },
    ];

    return steps;
  }

  changeStep(step) {
    trackPageView(step === (this.getSteps().length - 1) ? 'Checkout' : 'Packages' );

    return this.props.goToStep(step);
  }

  render() {
    const steps = this.getSteps();
    let { currentStep } = this.props;
    const { isPrepay } = this.props;

    if (steps.length > 2 && currentStep === 1 || isPrepay) currentStep = 2;
    if (this.props.snapSell) currentStep = steps.length;

    return (
      <Wizard
        currentStep={currentStep}
        additionalStepProps={{ snapSell: this.props.snapSell }}
        steps={steps}
        onStepChange={this.changeStep.bind(this)}
        history={this.props.history}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  currentStep: state.checkoutWizard.get('currentStep'),
  currentUser: state.currentUser.get('data'),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(checkoutWizardActions, dispatch),
  ...bindActionCreators(countriesActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(PublisherCheckoutWizardContainer);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/PublisherCheckoutWizardContainer.jsx